"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var validateBirthdate = function (value) {
    var rawValue = value.replace(/[^0-9a-zA-Z]/g, '');
    var date = (0, date_fns_1.parseISO)(value);
    var today = new Date();
    var isAValidDate = rawValue.length === 8 && (0, date_fns_1.isValid)(date);
    var isOfAge = (0, date_fns_1.differenceInYears)(today, date) > 17
        && (0, date_fns_1.differenceInYears)(today, date) < 101;
    if (!isAValidDate || !isOfAge) {
        return 'Data inválida';
    }
    return false;
};
exports.default = validateBirthdate;
//# sourceMappingURL=birthdate.js.map